import { useEffect } from "react";

/**
 * CalEmbedSetup
 * Injects the Cal.com element-click embed script once.
 * Any element with data-cal-link / data-cal-namespace will then open the Cal popup.
 */
export default function CalEmbedSetup() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.Cal && window.Cal.loaded) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
(function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "https://app.cal.com/embed/embed.js", "init");
Cal("init", "15min", {origin:"https://app.cal.com"});

Cal.ns["15min"]("ui", {"cssVarsPerTheme":{"light":{"cal-brand":"#6fa8fa"},"dark":{"cal-brand":"#ffffff"}},"hideEventTypeDetails":false,"layout":"month_view"});
`;

    document.head.appendChild(script);
  }, []);

  return null;
}

